'use client'

import { useEffect } from 'react'

/**
 * When the app refuses to take tickets because an on-sale line is live
 * (403 with `x-phantom-line: required`, see lib/onsale-line/gate), send the
 * buyer to the line instead of showing an error. One wrapper around
 * window.fetch, installed once, so every cart and seat-hold call is covered
 * without touching each caller.
 */
let installed = false

export default function LineFetchGuard() {
  useEffect(() => {
    if (installed || typeof window === 'undefined') return
    installed = true
    const original = window.fetch.bind(window)
    window.fetch = async (input: RequestInfo | URL, init?: RequestInit) => {
      const res = await original(input, init)
      if (res.status === 403 && res.headers.get('x-phantom-line') === 'required') {
        try {
          const body = await res.clone().json()
          const here = `${window.location.pathname}${window.location.search}`
          let target = typeof body?.lineUrl === 'string' && body.lineUrl.startsWith('/__line') ? body.lineUrl : '/__line'
          // Return to the page the buyer is on, not wherever the API guessed.
          const u = new URL(target, window.location.origin)
          u.searchParams.set('return', here)
          target = `${u.pathname}${u.search}`
          window.location.assign(target)
        } catch { /* leave the response to the caller */ }
      }
      return res
    }
  }, [])
  return null
}
